import request from '@/utils/request'

// 到货异常列表
export function fetchList(params) {
	return request({
		url: '/scm/deliverOrder/expGoodsList',
		method: 'post',
		data: params
	})
}

// 异常类型
export function getAllExpList() {
	return request({
		url: '/scm/dict/list',
		method: 'get'
	})
}

// 释放采购需求
export function releasePurchase(data) {
	return request({
		url: 'scm/deliverOrder/expGoodsList/repurchase',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/sms/error-order.js